import type { BuilderModels } from "../builder.models.types";

export function getBuilderModelName(model: BuilderModels) {
  return model;
}
